import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { NavGroup } from "./styles";
import { NavLink } from "react-router-dom";
import Collapse from "@material-ui/core/Collapse";
import Divider from "@material-ui/core/Divider";

class MenuItems extends Component {
  constructor(props) {
    super(props);

    this.state = {
      openedCustomers: false,
      openedReports: false,
      openedCompany: false,
      openedAdministrative: false,
      openedComissions: false,
      openedAtendimento: false,
      openedPesquisador: false,
      openedFinanceiro: false,
    };
  }

  handleOpened = (name, val) => {
    if (this.props.fit) {
      return;
    }
    this.setState({ [name]: !val });
  };

  handlePermissions = (permission) => {
    return this.props.permissions.data.indexOf(permission) > -1 ||
      this.props.master
      ? true
      : false;
  };

  componentDidMount() {
    let subs = document.getElementsByClassName("sub-menu");
    for (let i = 0; i < subs.length; i++) {
      if (subs[i].getElementsByTagName("li").length === 0) {
        document.getElementById(`menu-${i}`).style.display = "none";
      }
    }
  }

  render() {
    const tenant = localStorage.getItem("@ecorban-app:tenant");

    return (
      <Fragment>
        <Fragment>
          <Collapse in={true} collapsedHeight="7.2rem" id="menu-100">
            <div className="display-flex">
              {this.handlePermissions("VISUALIZAR DASHBOARD") && (
                <NavGroup className="default-link-row">
                  <li>
                    <NavLink
                      to={`/${tenant}/dashboard`}
                      className="default-link "
                    >
                      <div>
                        <i className="fa fa-tachometer" />
                        <small>Dashboard</small>
                      </div>
                    </NavLink>
                  </li>
                </NavGroup>
              )}
              {this.handlePermissions("LISTAR CLIENTES") && (
                <NavGroup className="default-link-row">
                  <li>
                    <NavLink
                      to={`/${tenant}/clientes`}
                      className="default-link default-link-row"
                    >
                      <div>
                        <i className="fa fa-users" />
                        <small>Clientes</small>
                      </div>
                    </NavLink>
                  </li>
                </NavGroup>
              )}
              {this.handlePermissions("LISTAR PROPOSTAS") && (
                <NavGroup className="default-link-row">
                  <li>
                    <NavLink
                      to={`/${tenant}/propostas`}
                      className="default-link default-link-row"
                    >
                      <div>
                        <i className="fa fa-copy" />
                        <small>Propostas</small>
                      </div>
                    </NavLink>
                  </li>
                </NavGroup>
              )}
            </div>
          </Collapse>
          <Divider />
        </Fragment>

        {((!!this.props.pesquisador_module && !!this.props.pesquisador) ||
          !!this.props.super_user) && (
          <Collapse
            in={this.state.openedPesquisador && !this.props.fit}
            collapsedHeight="7.2rem"
            timeout={200}
          >
            <NavGroup opened={this.state.openedPesquisador}>
              <li>
                <div
                  onClick={() =>
                    this.handleOpened(
                      "openedPesquisador",
                      this.state.openedPesquisador
                    )
                  }
                >
                  <i className="fa fa-search" />
                  <p>
                    <span>Pesquisador</span>
                    <small>D. Cadastrais, Consignado INSS</small>
                  </p>
                  <i className="fa fa-angle-up" />
                </div>
                <ul>
                  <li>
                    <NavLink to={`/${tenant}/dados-cadastrais`}>
                      Dados Cadastrais
                    </NavLink>
                  </li>
                  <li>
                    <NavLink to={`/${tenant}/consignado-inss`}>
                      Consignado INSS
                    </NavLink>
                  </li>
                  <li>
                    <NavLink to={`/${tenant}/calendario-uso-pesquisador`}>
                      Calendário de Uso
                    </NavLink>
                  </li>
                </ul>
              </li>
            </NavGroup>
          </Collapse>
        )}
        <Divider />
        <Collapse
          in={this.state.openedAtendimento && !this.props.fit}
          collapsedHeight="7.2rem"
          timeout={200}
          id="menu-0"
        >
          <NavGroup opened={this.state.openedAtendimento}>
            <li>
              <div
                onClick={() =>
                  this.handleOpened(
                    "openedAtendimento",
                    this.state.openedAtendimento
                  )
                }
              >
                <i className="fa fa-phone" />
                <p>
                  <span>Atendimento</span>
                  <small>Campanhas, Relatórios, Formas</small>
                </p>
                <i className="fa fa-angle-up" />
              </div>
              <ul className="sub-menu">
                {this.handlePermissions("LISTAR CAMPANHAS") && (
                  <li>
                    <NavLink to={`/${tenant}/campanhas`}>Campanhas</NavLink>
                  </li>
                )}
                {this.handlePermissions("LISTAR STATUS DE ATENDIMENTO") && (
                  <li>
                    <NavLink to={`/${tenant}/status-de-atendimento`}>
                      Status de Atendimento
                    </NavLink>
                  </li>
                )}
                {this.handlePermissions("LISTAR FORMAS DE ATENDIMENTO") && (
                  <li>
                    <NavLink to={`/${tenant}/formas-de-atendimento`}>
                      Formas de Atendimento
                    </NavLink>
                  </li>
                )}
                {this.handlePermissions("GERAR RELATÓRIO") && (
                  <li>
                    <NavLink to={`/${tenant}/relatorio-de-atendimento`}>
                      Relatório
                    </NavLink>
                  </li>
                )}
              </ul>
            </li>
          </NavGroup>
        </Collapse>
        <Divider />
        <Collapse
          in={this.state.openedReports}
          collapsedHeight="7.2rem"
          id="menu-1"
        >
          <NavGroup opened={this.state.openedReports}>
            <li>
              <div
                onClick={() =>
                  this.handleOpened("openedReports", this.state.openedReports)
                }
              >
                <i className="fa fa-bar-chart" />
                <p>
                  <span>Relatórios</span>
                  <small>Desempenho, Rankings, Metas</small>
                </p>
                <i className="fa fa-angle-up" />
              </div>
              <ul className="sub-menu">
                {this.handlePermissions("GERAR DESEMPENHO") && (
                  <li>
                    <NavLink to={`/${tenant}/desempenho`}>Desempenho</NavLink>
                  </li>
                )}
                {this.handlePermissions("GERAR RANKINGS") && (
                  <li>
                    <NavLink to={`/${tenant}/rankings`}>Rankings</NavLink>
                  </li>
                )}
                {this.handlePermissions("GERAR RELATÓRIO DE METAS") && (
                  <li>
                    <NavLink to={`/${tenant}/relatorio-metas`}>Metas</NavLink>
                  </li>
                )}
                {this.handlePermissions("VISUALIZAR ORGANOGRAMA") && (
                  <li>
                    <NavLink to={`/${tenant}/organograma`}>Organograma</NavLink>
                  </li>
                )}
                {this.handlePermissions("GERAR VALORES DIÁRIO") && (
                  <li>
                    <NavLink to={`/${tenant}/valores-diarios`}>
                      Valores Diários
                    </NavLink>
                  </li>
                )}
              </ul>
            </li>
          </NavGroup>
        </Collapse>
        <Divider />
        <Collapse
          in={this.state.openedCompany}
          collapsedHeight="7.2rem"
          id="menu-2"
        >
          <NavGroup opened={this.state.openedCompany}>
            <li>
              <div
                onClick={() =>
                  this.handleOpened("openedCompany", this.state.openedCompany)
                }
              >
                <i className="fa fa-building" />
                <p>
                  <span>Empresa</span>
                  <small>Regiões, Lojas, Grupos, Usuários</small>
                </p>
                <i className="fa fa-angle-up" />
              </div>
              <ul className="sub-menu">
                {this.handlePermissions("LISTAR CARGOS") && (
                  <li>
                    <NavLink to={`/${tenant}/cargos`}>Cargos</NavLink>
                  </li>
                )}
                {this.handlePermissions("CADASTRAR COMUNICADOS") && (
                  <li>
                    <NavLink to={`/${tenant}/comunicados`}>Comunicados</NavLink>
                  </li>
                )}
                {this.handlePermissions("LISTAR FERIADOS") && (
                  <li>
                    <NavLink to={`/${tenant}/feriados`}>Feriados</NavLink>
                  </li>
                )}
                {this.handlePermissions("LISTAR GRUPOS DE ACESSOS") && (
                  <li>
                    <NavLink to={`/${tenant}/grupos-de-acessos`}>
                      Grupos de Acessos
                    </NavLink>
                  </li>
                )}
                {this.handlePermissions("LISTAR LOJAS") && (
                  <li>
                    <NavLink to={`/${tenant}/lojas`}>Lojas</NavLink>
                  </li>
                )}
                {this.handlePermissions("LISTAR REGIÕES") && (
                  <li>
                    <NavLink to={`/${tenant}/regioes`}>Regiões</NavLink>
                  </li>
                )}
                {this.handlePermissions("LISTAR TIPOS DE USUÁRIO") && (
                  <li>
                    <NavLink to={`/${tenant}/tipos-de-usuario`}>
                      Tipos de Usuário
                    </NavLink>
                  </li>
                )}
                {this.handlePermissions("LISTAR USUÁRIOS") && (
                  <li>
                    <NavLink to={`/${tenant}/usuarios`}>Usuários</NavLink>
                  </li>
                )}
              </ul>
            </li>
          </NavGroup>
        </Collapse>
        <Divider />
        <Collapse
          in={this.state.openedAdministrative}
          collapsedHeight="7.2rem"
          id="menu-3"
        >
          <NavGroup opened={this.state.openedAdministrative}>
            <li>
              <div
                onClick={() =>
                  this.handleOpened(
                    "openedAdministrative",
                    this.state.openedAdministrative
                  )
                }
              >
                <i className="fa fa-folder" />
                <p>
                  <span>Administrativo</span>
                  <small>Bancos, Operações, Status</small>
                </p>
                <i className="fa fa-angle-up" />
              </div>
              <ul className="sub-menu">
                {this.handlePermissions("LISTAR BANCOS") && (
                  <li>
                    <NavLink to={`/${tenant}/bancos`}>Bancos</NavLink>
                  </li>
                )}

                {(this.handlePermissions("LISTAR BORDERÔS DE REMESSA") ||
                  this.handlePermissions("LISTAR BORDERÔS DE BANCO")) && (
                  <li>
                    <NavLink to={`/${tenant}/borderos`}>
                      Borderôs / Malotes
                    </NavLink>
                  </li>
                )}
                {this.handlePermissions("LISTAR OPERAÇÕES") && (
                  <li>
                    <NavLink to={`/${tenant}/operacoes`}>Operações</NavLink>
                  </li>
                )}
                {this.handlePermissions("LISTAR ORIGEM DA VENDA") && (
                  <li>
                    <NavLink to={`/${tenant}/origem-da-venda`}>
                      Origem da Venda
                    </NavLink>
                  </li>
                )}
                {this.handlePermissions("LISTAR PROMOTORAS") && (
                  <li>
                    <NavLink to={`/${tenant}/promotoras`}>Promotoras</NavLink>
                  </li>
                )}
                {this.handlePermissions("LISTAR PRODUTOS") && (
                  <li>
                    <NavLink to={`/${tenant}/produtos`}>Produtos</NavLink>
                  </li>
                )}
                {this.handlePermissions("LISTAR STATUS DE PROPOSTA") && (
                  <li>
                    <NavLink to={`/${tenant}/status-de-proposta`}>
                      Status de Proposta
                    </NavLink>
                  </li>
                )}
                {this.handlePermissions("LISTAR METAS") && (
                  <li>
                    <NavLink to={`/${tenant}/metas`}>Metas</NavLink>
                  </li>
                )}
                {this.handlePermissions("LISTAR MATERIAIS DE APOIO") && (
                  <li>
                    <NavLink to={`/${tenant}/materiais-de-apoio`}>
                      Materiais de Apoio
                    </NavLink>
                  </li>
                )}
                {this.handlePermissions(
                  "CADASTRAR COMISSÕES PARA AS PROPOSTAS"
                ) && (
                  <li>
                    <NavLink to={`/${tenant}/importacoes`}>Importações</NavLink>
                  </li>
                )}
              </ul>
            </li>
          </NavGroup>
        </Collapse>
        <Divider />
        <Collapse
          in={this.state.openedComissions}
          collapsedHeight="7.2rem"
          id="menu-4"
        >
          <NavGroup opened={this.state.openedComissions}>
            <li>
              <div
                onClick={() =>
                  this.handleOpened(
                    "openedComissions",
                    this.state.openedComissions
                  )
                }
              >
                <i className="fa fa-exchange" />
                <p>
                  <span>Comissionamento</span>
                  <small>Extratos, Repasses, Convênios</small>
                </p>
                <i className="fa fa-angle-up" />
              </div>
              <ul className="sub-menu">
                {this.handlePermissions("LISTAR GRUPOS DE REPASSES") && (
                  <li>
                    <NavLink to={`/${tenant}/grupos-de-repasses`}>
                      Grupos de Repasses
                    </NavLink>
                  </li>
                )}
                {this.handlePermissions("GERAR EXTRATO DE REPASSES") && (
                  <li>
                    <NavLink to={`/${tenant}/extrato-pago`}>
                      Extrato Pago
                    </NavLink>
                  </li>
                )}
                {this.handlePermissions("GERAR REPASSES") && (
                  <li>
                    <NavLink to={`/${tenant}/gerar-repasses`}>
                      Gerar Repasses
                    </NavLink>
                  </li>
                )}
                {this.handlePermissions("LISTAR TABELAS DE CONVÊNIOS") && (
                  <li>
                    <NavLink to={`/${tenant}/tabelas-de-convenios`}>
                      Tabelas de Convênios
                    </NavLink>
                  </li>
                )}
                {this.handlePermissions("LISTAR CATEGORIAS BÔNUS/DESCONTO") && (
                  <li>
                    <NavLink to={`/${tenant}/categorias-bonus-desconto`}>
                      Categorias Bônus/Desconto
                    </NavLink>
                  </li>
                )}
                {this.handlePermissions(
                  "LISTAR BÔNUS/DESCONTOS PROGRAMADOS"
                ) && (
                  <li>
                    <NavLink to={`/${tenant}/bonus-desconto`}>
                      Bônus/Descontos Programados
                    </NavLink>
                  </li>
                )}
              </ul>
            </li>
          </NavGroup>
        </Collapse>
        <Divider />
        <Collapse
          in={this.state.openedFinanceiro}
          collapsedHeight="7.2rem"
          id="menu-5"
        >
          <NavGroup opened={this.state.openedFinanceiro}>
            <li>
              <div
                onClick={() =>
                  this.handleOpened(
                    "openedFinanceiro",
                    this.state.openedFinanceiro
                  )
                }
              >
                <i className="fa fa-money" />
                <p>
                  <span>Financeiro</span>
                  <small>Categorias, Métodos, Extrato</small>
                </p>
                <i className="fa fa-angle-up" />
              </div>
              <ul className="sub-menu">
                {this.handlePermissions("LISTAR CATEGORIAS DE PAGAMENTOS") && (
                  <li>
                    <NavLink to={`/${tenant}/categorias-de-pagamentos`}>
                      Categorias de Pagamento
                    </NavLink>
                  </li>
                )}
                {this.handlePermissions(
                  "LISTAR CATEGORIAS DE RECEBIMENTOS"
                ) && (
                  <li>
                    <NavLink to={`/${tenant}/categorias-de-recebimentos`}>
                      Categorias de Recebimento
                    </NavLink>
                  </li>
                )}
                {this.handlePermissions("LISTAR CONTAS BANCÁRIAS") && (
                  <li>
                    <NavLink to={`/${tenant}/contas-bancarias`}>
                      Contas Bancárias
                    </NavLink>
                  </li>
                )}
                {this.handlePermissions("LISTAR MÉTODOS DE PAGAMENTOS") && (
                  <li>
                    <NavLink to={`/${tenant}/metodos-de-pagamentos`}>
                      Métodos de Pagamento
                    </NavLink>
                  </li>
                )}
                {this.handlePermissions("LISTAR LANÇAMENTOS") && (
                  <li>
                    <NavLink to={`/${tenant}/lancamentos`}>Lançamentos</NavLink>
                  </li>
                )}
                {this.handlePermissions("LISTAR EXTRATO FINANCEIRO") && (
                  <li>
                    <NavLink to={`/${tenant}/extrato`}>Extrato</NavLink>
                  </li>
                )}
              </ul>
            </li>
          </NavGroup>
        </Collapse>
        <Divider />
        {!!this.props.master && (
          <Fragment>
            <Collapse in={true} collapsedHeight="7.2rem" id="menu-99">
              <NavGroup>
                <li>
                  <NavLink to={`/${tenant}/ajuda`} className="default-link">
                    <div>
                      <i className="fa fa-question-circle" />
                      <p>
                        <span>Ajuda</span>
                        <small>Guia Inicial, Vídeos, Suporte</small>
                      </p>
                      <i className="fa fa-angle-up" />
                    </div>
                  </NavLink>
                </li>
              </NavGroup>
            </Collapse>
            <Divider />
          </Fragment>
        )}
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  permissions: state.permissions,
  master: state.permissions.master,
  pesquisador_module: state.permissions.pesquisador_module,
  pesquisador: state.permissions.pesquisador,
  super_user: state.permissions.super_user,
  page: state.pages,
});

export default connect(mapStateToProps, null)(MenuItems);



// WEBPACK FOOTER //
// ./src/components/MenuItems/index.js